export class Rolepermission {
  
}
